import { HiExclamationTriangle, HiWifi, HiArrowPath } from 'react-icons/hi2';
import type { AudioError } from '../../hooks/useAudioPlayer';

interface ErrorDisplayProps {
  error: AudioError;
  onRetry?: () => void;
  isLive?: boolean;
}

export function ErrorDisplay({ error, onRetry, isLive = false }: ErrorDisplayProps) {
  const getIcon = () => {
    switch (error.code) {
      case 'network':
        return <HiWifi size={20} />;
      default:
        return <HiExclamationTriangle size={20} />;
    }
  };

  const getMessage = () => {
    if (isLive && error.code === 'network') {
      return 'Stream temporarily unavailable';
    }
    return error.message;
  };

  return (
    <div
      className="mx-4 mb-3 px-4 py-3 bg-red-500/10 rounded-[var(--radius-md)]
                 border border-red-500/20"
      role="alert"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 text-red-500">
          {getIcon()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-red-600 dark:text-red-400">
            {getMessage()}
          </p>
          {error.canRetry && (
            <p className="text-xs text-red-500/70 mt-1">
              {isLive ? 'Will reconnect automatically...' : 'Click retry to try again'}
            </p>
          )}
        </div>
        {error.canRetry && onRetry && (
          <button
            onClick={onRetry}
            className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5
                     bg-red-500/20 hover:bg-red-500/30
                     text-red-600 dark:text-red-400 text-xs font-medium
                     rounded-full transition-colors
                     focus:outline-none focus-visible:ring-2
                     focus-visible:ring-red-500"
          >
            <HiArrowPath size={14} />
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
